import { useMutation, useQuery } from "react-query";
import { HttpBaseRequest } from "../../../../core/HttpRequest";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import { AxiosError } from "axios";
import useSuccessHandler from "../../../../hooks/useSuccessHandler";
import {
  addSubDealer,
  getSubDealer,
  getSubDealers,
  updateSubDealer,
} from "./service";
import { Form_Create_Dealer, Form_Update_Dealer } from "../../form/Form";

export const useGetSubDealers = ({
  keyword,
  page,
  perPage,
}: HttpBaseRequest) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: `subDealer-${keyword}-${page}-${perPage}`,
    queryFn: () => getSubDealers({ keyword, page, perPage }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetSubDealer = ({
  sub_dealer_id,
}: {
  sub_dealer_id?: string;
}) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: sub_dealer_id !== undefined,
    queryKey: `subDealer-${sub_dealer_id}`,
    queryFn: () => getSubDealer({ sub_dealer_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddSubDealer = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: `addSupplier`,
    mutationFn: ({
      sub_dealer_address,
      sub_dealer_name,
      sub_dealer_phone_number,
    }: Form_Create_Dealer) =>
      addSubDealer({
        sub_dealer_address,
        sub_dealer_name,
        sub_dealer_phone_number,
      }),
    onSuccess: (e) => {
      showToast("Berhasil menambahkan subdealer baru");
      redirect("/dealer");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useUpdateSubDealer = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: `updateSupplier`,
    mutationFn: ({
      sub_dealer_address,
      sub_dealer_id,
      sub_dealer_name,
      sub_dealer_phone_number,
    }: Form_Update_Dealer) =>
      updateSubDealer({
        sub_dealer_address,
        sub_dealer_id,
        sub_dealer_name,
        sub_dealer_phone_number,
      }),
    onSuccess: (e) => {
      showToast("Berhasil update subdealer");
      redirect("/dealer");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
